import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, User } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);

      if (!sessionIdMatch) {
        navigate('/', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        localStorage.setItem('magicmix_user', JSON.stringify(response.data.user));
        toast.success("La tua privacy è importante, i tuoi dati sono al sicuro sotto il tuo profilo", {
          duration: 5000,
          icon: <User size={16} />
        });
        navigate('/', { replace: true, state: { user: response.data.user } });
      } catch (err) {
        console.error("Auth error:", err);
        toast.error("Authentication failed. Please try again.");
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="auth-callback" data-testid="auth-callback">
      <Loader2 className="spin" size={48} />
      <p>Signing you in...</p>
    </div>
  );
};

export default AuthCallback;
